<template>
  <div>
    <!-- 待确认核销列表 -->
    <el-dialog
      title="待确认核销列表"
      :visible.sync="dialogVisible"
      :before-close="close"
      width="1000px"
    >
      <div class="pending-confirm-wrapper">
        <div class="handler">
          <el-button type="primary" size="small" :loading="confirming" @click="batchConfirm">批量确认核销</el-button>
        </div>
        <el-table
          ref="pendingTable"
          :data="tableData"
          v-loading="loading"
          border
          @selection-change="handleSelectionChange"
          style="width: 100%"
        >
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column prop="id" align="center" label="核销批次" min-width="100"></el-table-column>
          <el-table-column prop="spuName" align="center" label="核销油品" min-width="90"></el-table-column>
          <el-table-column prop="billTotalAmount" align="center" label="账单总金额" min-width="110"></el-table-column>
          <el-table-column prop="createTime" align="center" label="提交时间" min-width="140"></el-table-column>
          <el-table-column prop="invoiceCode" align="center" label="发票代码" min-width="100"></el-table-column>
          <el-table-column prop="invoiceNo" align="center" label="发票号码" min-width="100"></el-table-column>
          <el-table-column prop="verificationStatusStr" align="center" label="确认状态" min-width="120"></el-table-column>
          <el-table-column align="center" label="操作" width="160" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" :disabled="confirming" @click="confirmRow(scope.row)">确认核销</el-button>
              <el-button type="text" size="small" @click="showDetail(scope.row)">账单信息</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.pageIndex"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <pending-confirm-detail
      v-if="Object.keys(detailParams).length"
      :data="detailParams"
      @close="detailParams = {}"
    />
  </div>
</template>
<script>
import { pendingConfirmRecords, confirmVerification } from '@/api/finance'
import PendingConfirmDetail from './pendingConfirmDetail'

export default {
  name: 'PendingConfirmDialog',
  components: {
    PendingConfirmDetail
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      confirming: false,
      tableData: [],
      detailParams: {},
      selection: [],
      pagination: {
        pageIndex: 1,
        pageSize: 10
      },
      total: 0
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.pagination.pageIndex = 1
        this.getList()
      }
    }
  },
  methods: {
    async getList () {
      try {
        this.loading = true
        const { code, result = [], totalRow = 0 } = await pendingConfirmRecords({
          pageIndex: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize
        })
        if (code !== 200) {
          this.tableData = []
          this.total = 0
          return
        }
        this.tableData = result
        this.total = parseInt(totalRow)
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    handleSelectionChange (selection) {
      this.selection = selection
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.pagination.pageIndex = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.pagination.pageIndex = val
      this.getList()
    },
    async confirmRow (row) {
      await this.confirmVerificationSubmit(
        { ids: row.id },
        '确认核销当前批次吗？'
      )
    },
    async batchConfirm () {
      if (!this.selection.length) return this.$message.warning('请选择核销批次')
      const ids = this.selection.map(item => item.id).join(',')
      await this.confirmVerificationSubmit(
        { ids },
        `确认核销已选中的${this.selection.length}个批次吗？`
      )
    },
    async confirmVerificationSubmit (params, message) {
      try {
        await this.$confirm(message, '确认提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.confirming = true
        const { code } = await confirmVerification(params)
        if (code !== 200) return
        this.$message.success('操作成功')
        this.$refs.pendingTable.clearSelection()
        this.getList()
        this.$emit('confirmed')
      } catch (err) {
        if (err !== 'cancel' && err !== 'close') {
          console.log(err)
        }
      } finally {
        this.confirming = false
      }
    },
    showDetail (row) {
      this.detailParams = {
        id: row.id,
        billMonth: row.billDay,
        gasId: row.gasId,
        oilNo: row.oilNo === undefined || row.oilNo === null ? 0 : row.oilNo
      }
    },
    close () {
      this.detailParams = {}
      this.dialogVisible = false
    },
    refresh () {
      this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
.pending-confirm-wrapper {
  .handler {
    margin-bottom: 16px;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
